
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {BaseRecordModel,
        SelectRecordScreenElementModel} from '../../models/modelsFlow';
import {checkLayoutFieldRequirement} from '../../utils/fieldValidations';

export const SelectRecordElementComponent: React.FC<{
  element: SelectRecordScreenElementModel,
  onChange: (value: BaseRecordModel, element: SelectRecordScreenElementModel) => void,
}> = ( {
  element,
  onChange
}) => {

  const handleChange = (event: any) => {
    const value = event.target.value;
    const selectedRecord = element.records.find((thisRecord: BaseRecordModel) => thisRecord.Uuid_sys === value);
    if(selectedRecord) onChange(selectedRecord, element)
  }

  const required = true;

  const selectedRecord = element.selectedRecord;

  const error = () => {
    if(required && !selectedRecord) return true
    return false
  };

  const displayValue = () => {
    if(selectedRecord) return selectedRecord.Uuid_sys;
    return ""
  }

  return (
      <FormControl
         fullWidth
         variant="filled"
         >
         <InputLabel
            required={required}
            error={error()}>
              Select
          </InputLabel>

         <Select
            value={displayValue()}
            onChange={(event) => handleChange(event)}
            size="small"
            disabled={false}
        >
           {element.records.map((thisRecord: BaseRecordModel) => {
             return (
               <MenuItem
                 key={thisRecord.Uuid_sys}
                 value={thisRecord.Uuid_sys}
               >
                 {thisRecord.displayValue}
               </MenuItem>
             )}
           )}
         </Select>

      </FormControl>

    );

};
